// extracted by mini-css-extract-plugin
export default {"wrapperApp":"WrapperApp_wrapperApp__Dg3xp"};